export default "__VITE_ASSET__CtV6PK4L__"